// import React, { useState } from "react";
// import API from "../api";

// const UploadImage = () => {
//   const [file, setFile] = useState(null);
//   const [url, setUrl] = useState("");

//   const handleUpload = async () => {
//     const formData = new FormData();
//     formData.append("image", file);

//     try {
//       const res = await API.post("/upload", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       setUrl(res.data.url); // Cloudinary URL
//       alert("Upload successful!");
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <div>
//       <input
//         type="file"
//         onChange={(e) => setFile(e.target.files[0])}
//         accept="image/*"
//       />
//       <button onClick={handleUpload}>Upload</button>
//       {url && (
//         <div>
//           <p>Image URL:</p>
//           <img src={url} alt="uploaded" width="200" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadImage;
import React, { useState } from "react";
import API from "../api";

const UploadImage = ({ onUploadComplete }) => {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      // const res = await API.post("/upload", formData, {
        const res = await API.post("https://movie-backend-1wmv.onrender.com/api/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setUrl(res.data.url);
      if (onUploadComplete) onUploadComplete(res.data.url);
      alert("✅ Upload successful!");
    } catch (err) {
      console.error(err);
      alert("❌ Upload failed");
    }
  };

  return (
    <div>
      <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
        accept="image/*"
      />
      <button
        type="button"
        onClick={handleUpload}
        disabled={!file}
        className="btn btn-secondary btn-sm ms-2"
      >
        Upload
      </button>
      {url && (
        <div className="mt-2">
          <img src={url} alt="uploaded" width="120" />
        </div>
      )}
    </div>
  );
};

export default UploadImage;
